import type { PlatformAccessGrant } from '@sentinel/shared';
import type { StateTone } from '@sentinel/ui';

const TONE: Record<PlatformAccessGrant['status'], StateTone> = {
  pending: 'info',
  approved: 'ok',
  denied: 'off',
  expired: 'off',
  revoked: 'off',
};

export function grantTone(grant: PlatformAccessGrant): StateTone {
  return TONE[grant.status];
}

/** An approved window still open: it can be entered now. */
export function isEnterable(grant: PlatformAccessGrant, now: number = Date.now()): boolean {
  return (
    grant.status === 'approved' && grant.expiresAt !== null && Date.parse(grant.expiresAt) > now
  );
}
